import React from 'react'
import { TranslateFunction } from '@/utils/translate/translate-client'

export enum GiveawayTabEnum {
  Details = 'Details',
  Updates = 'Updates',
  Faq = 'Faq',
  Prizes = 'Prizes',
  VacationPackages = 'VacationPackages',
}

// Tab and component types
export type GiveawayTab = {
  title: string
  type: GiveawayTabEnum
}

export type GiveawayHowToStep = {
  title: string
  description: string
}

export type PartnerLogo = {
  src: string
  alt: string
}

export type GiveawayPrizeItem = {
  image: string
  alt: string
  title: string
  value?: string
  url?: string
  sponsorName?: string
  representativePrizeShown?: boolean
}

export type GalleryImage = {
  src: string
  alt: string
}

export type GiveawayShare = {
  shareText: string
  hashtag: string
  shareImage: string
  shareImageMobile: string
}

export type CongratsModal = {
  text: string
  image: string
  alt: string
}

export type SummaryPage = {
  image: string
  alt: string
}

export type ReservationCompletePage = {
  image: string
  alt: string
  text: string
}

export type NoShowtimes = {
  image: string
  text: string
}

export interface GiveawayConfigBase {
  theatricalSlug: string
  heroTitle: string
  logoUrl: string
  footerLogoUrl?: string
  footerBgImage?: string
  inTheatersText: string
  releaseDate?: string
  rulesLink?: string
  videoImage?: string
  backgroundVideoUrl?: string
}

export interface TicketFlowConfig {
  congratsModal: {
    text: string
    image: string
    alt: string
  }
  reservationCompletePage: {
    image: string
    alt: string
    text: string
  }
  noShowtimes?: {
    image: string
    text: string
  }
}

export interface GiveawayConfig extends GiveawayConfigBase {
  share?: GiveawayShare
  ticketFlow?: TicketFlowConfig
  steps?: GiveawayHowToStep[]
  partnerLogos?: PartnerLogo[]
  prizes?: GiveawayPrizeItem[]
  galleryImages: GalleryImage[]
  tabs: Array<{
    title: string
    type: GiveawayTabEnum
  }>
}

export interface QuantityMultiplier {
  min: number
  max: number
  multiplier: number
}

export interface GiveawayRulesConfig {
  content: (t: TranslateFunction) => React.JSX.Element
}
